export default "__VITE_ASSET__CygQOw0o__"